import { PrivateComponentInProject } from 'components/auth';
import { SCOPE_TYPES } from 'constants/scopes';
import React from 'react';
import ProjectHeader from '../../ProjectHeader';
import Budgets from './components/Budgets';
import Virements from './components/Virements';

const BudgetVirement = () => {
  return (
    <ProjectHeader>
      <PrivateComponentInProject expectedScopeType={[SCOPE_TYPES.VIEW_BUDGET]}>
        {/* <div>test</div> */}
        <Budgets />
      </PrivateComponentInProject>
      <PrivateComponentInProject
        expectedScopeType={[SCOPE_TYPES.VIEW_VIREMENT]}
      >
        {/* <div>test</div> */}
        <Virements />
      </PrivateComponentInProject>
    </ProjectHeader>
  );
};

export default BudgetVirement;
